import * as yup from 'yup'
import { VALIDATION } from 'utils/globalConstant'

export const validationSchema = yup.object({
  date_from: yup.string().required(VALIDATION.required),
  date_to: yup.string().required(VALIDATION.required),
  clock_in_am: yup.string(),
  clock_out_am: yup.string(),
  clock_in_pm: yup.string(),
  clock_out_pm: yup.string(),
  location: yup.string().required(VALIDATION.required),
  reason: yup.string().required(VALIDATION.required),
})
